import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
// import * as gql from '../gql'

export const loadEnhancement = store.effects.create((feature: Feature) =>
  feature.actions.loadEnhancement.request.observe().pipe(
    rxjs.mergeMap(action =>
      // gql.queries.writingEnhancement.executor({ writing }).pipe(
      rxjs.of('This is the enhancement').pipe(
        rxjs.map(response =>
          feature.actions.loadEnhancement.success.from(action).create({
            request: action.data,
            response,
          }),
        ),
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.loadEnhancement.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      ),
    ),
  ),
)
